import { render, staticRenderFns } from "./AllAccounts.vue?vue&type=template&id=61f63e6d"
import script from "./AllAccounts.vue?vue&type=script&lang=ts"
export * from "./AllAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports